export interface ISidebarItem {
    id: string;
    name: string;
    icon?: string;
    isPrimaryAction: boolean;
    routerLink?: string;
}

export interface ISiderInstitutionItem {
    name: string;
    code: string;
    image?: string;
}